export function hexToRgb(hex) {
    hex = hex.replace("#", "");
    
    // Divise la couleur hexadécimale en trois parties : R, G et B
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    return `${r}, ${g}, ${b}`;
}